import asciiSize from "./component-library241.mjs";
import hasUnicode from "./component-library239.mjs";
import unicodeSize from "./component-library242.mjs";
function stringSize(string) {
  return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}
export {
  stringSize as default
};
